var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MIcon',{staticClass:"fa-spin",staticStyle:{"margin-top":"unset"},attrs:{"id":"loading-patch-btn","name":"spinner-third","size":"lg"}})
}
var staticRenderFns = []

export { render, staticRenderFns }